import React from "react"

import { useStyles } from "@/components/ProfileSection/TextInfo/TextInfo.styles"

export const TextInfo = ({ textInfo }: { textInfo: { title: string; subtitle: string } }) => {
    const { classes } = useStyles()

    return (
        <div className={classes.textInfo}>
            <div className={classes.title}>{textInfo.title}</div>
            <div className={classes.value}>{textInfo.subtitle}</div>
        </div>
    )
}
